__turbopack_context__.v({
  "sats": "InscriptionWarningExcessSats-module__u6mu6q__sats",
});
